import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export const ContactPanel = () => {
    const [ContactData, setContactData] = useState([]);
    const navigate = useNavigate();

   useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/contact_form_list"
      );
      setContactData(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/delete_contact_form",
        { form_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === 1) {
        setContactData((prevUser) =>
          prevUser.filter((user) => user.form_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/Contact");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Data.");
    }
  };

    return (
        <div className="container mt-5">
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr >
            <th colSpan="4" className=" text-center bg-white fs-4 text-black">Contact Table</th>
          </tr>
          <tr>
            <th className="text-white text-center table-custom">Name</th>
            <th className="text-white text-center table-custom">E-mail</th>
            <th className="text-white text-center table-custom">Message</th>
            <th className="text-white text-center table-custom">Actions</th>
          </tr>
        </thead>
        <tbody>
          {ContactData.map((Info, index) => (
            <tr key={index}>
               <td className="text-center">{Info.form_name}</td> 
              <td className="text-center"><strong>{Info.form_email}</strong></td>
              <td className="text-center"><strong>{Info.form_message}</strong></td>
              <td className="text-center">
                <button 
                    className="btn btn-danger btn-sm me-1"
                    onClick={() => deleteUser(Info.form_id)}
                  >
                    <i className="fa-regular fa-trash-can text-white"></i>
                  </button>                
              </td>
            </tr>
          ))}
        </tbody>
      </table> 
        </div>    
    );
};